import controller from './sensors.controller';

const template = require('./sensors.html');

export default {
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/sensors.component.js